import { render, staticRenderFns } from "./referFriend.vue?vue&type=template&id=51ba3e0a&scoped=true"
import script from "./referFriend.vue?vue&type=script&lang=js"
export * from "./referFriend.vue?vue&type=script&lang=js"
import style0 from "./referFriend.vue?vue&type=style&index=0&id=51ba3e0a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ba3e0a",
  null
  
)

export default component.exports